import React from 'react';
import apiClient from '../../../shared/services/apiClient';
import { useTranslation } from '../../../shared/i18n';
import CatalogTextsButton from '../../components/CatalogTextsButton';

/** System cache presets (cdn_cache_presets.is_system): customer-visible name / description per language. */
export default function CachePresetTexts({ size }) {
    const { t } = useTranslation();
    return (
        <CatalogTextsButton
            title={t('Cache presets')}
            size={size}
            descMax={500}
            load={async () => {
                const r = await apiClient.get('/api/admin/cdn/cache-presets');
                if (!r.data?.success) throw r.data;
                return r.data.data || [];
            }}
            save={async (row, v) => {
                const r = await apiClient.post('/api/admin/cdn/cache-presets/update', { id: row.id, ...v });
                if (!r.data?.success) throw r.data;
            }}
        />
    );
}
